"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPExpand = void 0;
var react_1 = __importStar(require("react"));
//MATERIAL UI components
var core_1 = require("@material-ui/core");
//componentes usados no Expand
var PPGrid_1 = require("../PPGrid/PPGrid");
//styles
var style_1 = require("./style");
require("../../assets/style.css");
/**
 * Painel de expansão
 * @param {ExpandPanelInterface} props Propriedades
 */
var PPExpand = function (props) {
    var iconPosition = function () {
        switch (props.iconPosition) {
            case "left":
                return react_1.default.createElement("i", { className: "ppi ppi-chevron-down", id: "closeIcon" });
            case "right":
                return react_1.default.createElement("i", { className: "ppi ppi-chevron-down", id: "closeIcon" });
            default:
                return react_1.default.createElement("i", { className: "ppi ppi-chevron-down", id: "closeIcon" });
        }
    };
    var classes = (0, style_1.useStyles)();
    var _a = (0, react_1.useState)(props.expanded || false), expanded = _a[0], setExpanded = _a[1];
    (0, react_1.useEffect)(function () {
        setExpanded(props.expanded);
    }, [props.expanded]);
    return (react_1.default.createElement(core_1.Accordion, __assign({}, props, { square: true, className: classes.styleAccordion, expanded: props.fixed || expanded, onChange: function () { setExpanded(!expanded); } }),
        react_1.default.createElement(core_1.AccordionSummary, { expandIcon: props.hideHeader ? null : props.iconPosition === "right" || !(props.iconPosition) ? iconPosition() : null, className: props.hideHeader ? classes.displayHeader : undefined },
            props.hideHeader ? null :
                props.iconPosition === "left" ? iconPosition() : null,
            props.hideHeader ? null :
                react_1.default.createElement(core_1.Typography, { className: props.iconPosition === "left" ? classes.titleLeft : classes.title }, props.title)),
        react_1.default.createElement(core_1.AccordionDetails, { className: props.hideHeader ? classes.contentsWithoutHeader : classes.contentsGrid }, props.children
            ? props.children
            : react_1.default.createElement(PPGrid_1.PPGrid, { contents: props.contents, fields: props.fields, disabled: props.disabled }))));
};
exports.PPExpand = PPExpand;
